/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notice_See_HotInputs */

const en_notice_see_hot = /** @type {(inputs: Notice_See_HotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See`)
};

/**
* | output |
* | --- |
* | "See" |
*
* @param {Notice_See_HotInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notice_see_hot = /** @type {((inputs?: Notice_See_HotInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notice_See_HotInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notice_see_hot(inputs)
});